import {Outlet} from "react-router-dom";
import Analytics from "./analytics";
import ErrorBoundary from "./error-boundary";
import Footer from "./footer";
import Navbar from "./navbar";
import Notice from "./notice";
import Notifications from "./notifications";

export default function Container() {
  return (
    <div className="flex flex-col h-screen">
      <Navbar />
      <Notice />
      <Notifications />
      <main>
        <ErrorBoundary><Outlet /></ErrorBoundary>
      </main>
      <Footer />
      <Analytics />
    </div>
  );
}
